import type { Transaction } from 'prosemirror-state';
import { TextSelection } from 'prosemirror-state';

export class ProsemirrorInsertTextManager {
	constructor(
		private interimTextFrom: number | null = null,
		private interimTextTo: number | null = null,
	) {}

	insertText(transcript: string, tr: Transaction): Transaction {
		if (!transcript) {
			return tr;
		}

		const { selection } = tr;
		let pos = selection.$head.pos;

		// set the initial position of the interim text and cache it
		if (this.interimTextFrom === null) {
			this.interimTextFrom = pos;
		} else {
			pos = this.interimTextFrom;
		}

		// Replace previous interim text atomically (or insert if none exists).
		// Using insertText(text, from, to) ensures ProseMirror places the cursor
		// at the end of the new text, avoiding dangling cursor positions.
		const replaceTo =
			this.interimTextFrom !== null && this.interimTextTo !== null ? this.interimTextTo : pos;
		tr.insertText(transcript, pos, replaceTo);
		this.interimTextTo = pos + transcript.length;

		tr.setSelection(TextSelection.create(tr.doc, this.interimTextTo));
		return tr;
	}

	rejectTranscriptedText(tr: Transaction): Transaction {
		const from = this.interimTextFrom;
		const to = this.interimTextTo;

		if (from === null || to === null) {
			return tr;
		}

		tr.delete(from, to);
		tr.setSelection(TextSelection.create(tr.doc, from));
		this.disposeTranscriptedText();

		return tr;
	}

	disposeTranscriptedText(): void {
		this.interimTextFrom = null;
		this.interimTextTo = null;
	}
}
